import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-white text-black">
      <div className="max-w-7xl mx-auto px-8">

        {/* Heading */}
        <div className="text-center mb-20">
          {/* Eyebrow */}
          <div className="mb-6 border-t border-b border-black py-4 inline-block">
            <span className="text-xs font-sans tracking-widest uppercase font-light">
              Contact Us
            </span>
          </div>

          {/* Main Heading */}
          <h2 className="text-6xl md:text-7xl font-black mt-6 mb-6" style={{fontFamily: 'Georgia, serif'}}>
            Get In Touch
          </h2>

          {/* Divider */}
          <div className="w-32 h-1 bg-black mx-auto mt-8 mb-8"></div>

          <p className="max-w-2xl mx-auto text-lg font-sans font-light text-gray-700">
            We're here to help and answer any questions you may have.
          </p>
        </div>

        {/* Contact Grid */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16">

          {/* Contact Info */}
          <div className="border-2 border-black p-10">
            <h3 className="text-3xl font-black mb-10" style={{fontFamily: 'Georgia, serif'}}>
              Contact Information
            </h3>

            <div className="space-y-8">

              {/* Address */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 border-2 border-black flex items-center justify-center flex-shrink-0">
                  <MapPin size={24} strokeWidth={1.5} />
                </div>
                <div>
                  <h4 className="font-black text-lg mb-2">Address</h4>
                  <p className="font-sans font-light text-base leading-relaxed text-gray-700">
                    124/B V.K.N Complex,<br />
                    Chitra Coffee Bar Upstairs,<br />
                    Chittoor Road, Katpadi,<br />
                    Vellore - 632007
                  </p>
                </div>
              </div>

              {/* Divider */}
              <div className="h-px bg-black"></div>

              {/* Phone */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 border-2 border-black flex items-center justify-center flex-shrink-0">
                  <Phone size={24} strokeWidth={1.5} />
                </div>
                <div>
                  <h4 className="font-black text-lg mb-2">Phone</h4>
                  <p className="font-sans font-light text-base text-gray-700">
                    +91 63799 55680
                  </p>
                </div>
              </div>

              {/* Divider */}
              <div className="h-px bg-black"></div>

              {/* Email */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 border-2 border-black flex items-center justify-center flex-shrink-0">
                  <Mail size={24} strokeWidth={1.5} />
                </div>
                <div>
                  <h4 className="font-black text-lg mb-2">Email</h4>
                  <p className="font-sans font-light text-base text-gray-700">
                    info@legallions.org
                  </p>
                </div>
              </div>

            </div>
          </div>

          {/* Contact Form */}
          <div className="border-2 border-black p-10">
            <h3 className="text-3xl font-black mb-10" style={{fontFamily: 'Georgia, serif'}}>
              Send us a Message
            </h3>

            <form className="space-y-5">

              <input
                type="text"
                placeholder="Full Name"
                className="w-full border-2 border-black bg-white px-4 py-3 font-sans font-light outline-none focus:bg-black focus:text-white transition"
              />

              <input
                type="email"
                placeholder="Email Address"
                className="w-full border-2 border-black bg-white px-4 py-3 font-sans font-light outline-none focus:bg-black focus:text-white transition"
              />

              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full border-2 border-black bg-white px-4 py-3 font-sans font-light outline-none focus:bg-black focus:text-white transition"
              />

              <textarea
                rows="5"
                placeholder="Your Message"
                className="w-full border-2 border-black bg-white px-4 py-3 font-sans font-light outline-none focus:bg-black focus:text-white transition resize-none"
              ></textarea>

              <button
                type="submit"
                className="w-full bg-black text-white font-sans font-bold py-3 uppercase tracking-wide hover:bg-gray-900 transition"
              >
                Send Message
              </button>

            </form>
          </div>

        </div>

      </div>
    </section>
  );
};

export default Contact;